import React from "react";
// src/pages/Webmail.jsx
const Webmail = () => {
  React.useEffect(() => {
    window.location.href = "https://webmail.oscarglobaltt.com";
  }, []);

  return <p>Redirecting to Webmail...</p>;
};

export default Webmail;
